module.exports = __webpack_public_path__ + "static/media/banner-user-4.5fd6ed7a.png";